export default __webpack_public_path__ + "img/timeline1-17b85013.png";